import { useEditor } from '@smartfire/js-block-engine';
import clsx from 'clsx';
import { ReactComponent as Logo } from '../../assets/MyHand-logo.svg';
import { Menu } from '../../components';
import style from './style.module.scss';

const HeaderDesktop = ({ menu, secondMenu, accountBlock = null, isLandingPage = false, isUserConnected = false }) => {
    const { isEditing } = useEditor();
    const WrapperLink = isEditing ? 'div' : 'a';

    return (
        <nav className={clsx(style.block, isLandingPage && style.landingPage)}>
            <WrapperLink href="/" className={clsx(style.logo, isLandingPage && style.landingPage)}>
                <Logo />
            </WrapperLink>
            {!isLandingPage && (
                <div className={style.menuContainer}>
                    <Menu menu={menu} classNames={style.firstMenu} isUserConnected={isUserConnected} />
                    <div className={style.separator} />
                    <Menu menu={secondMenu} classNames={style.secondMenu} isUserConnected={isUserConnected} />
                </div>
            )}
            {!isLandingPage && accountBlock}
        </nav>
    );
};

export default HeaderDesktop;
